export default __webpack_public_path__ + "static/media/1-4.b3bfb429.jpg";